<template>
    <div class="user-list">
      <h1>User List</h1>
      <ul>
        <li v-for="user in users" :key="user.pin" @click="selectUser(user.pin)">
          <strong>PIN:</strong> {{ user.pin }} - <strong>Gender:</strong> {{ user.gender }}
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        users: [],
      };
    },
    methods: {
      async fetchUsers() {
        const response = await axios.get('https://firefly-setup.athenarc.gr/users');
        this.users = response.data;
        console.log("user list is loaded")
      },
      selectUser(pin) {
        console.log('Debug: Navigating to user details with PIN:', pin);
        this.$router.push(`/user/${pin}`);
       },
    },
    mounted() {
      this.fetchUsers();
    },
  };
  </script>
  
  <style>
  .user-list ul {
    list-style-type: none;
    padding: 0;
  }
  .user-list li {
    cursor: pointer;
    margin: 10px 0;
    padding: 10px;
    background: #f0f0f0;
    border-radius: 8px;
  }
  .user-list li:hover {
    background: #d0d0d0;
  }
  </style>
  